import React from 'react'
import { arrayOf, object } from 'prop-types'

import styles from './ArticleTags.module.scss'
import Tag from '../Tag'

const ArticleTags = ({ tags }) => {
  if (!tags || tags.length === 0) return null
  return (
    <div className={styles.ArticleTags}>
      {tags.map((tag) => (
        <Tag
          href={`/search?q=${encodeURIComponent(tag.tag)}`}
          className={styles.Tag}
          background="grey"
          uppercase
          nofollow
          key={tag.tag}
        >
          {tag.tag}
        </Tag>
      ))}
    </div>
  )
}

ArticleTags.propTypes = {
  tags: arrayOf(object)
}

export default ArticleTags
